export default {
  create_title: 'Add webhook endpoint',
  edit_title: 'Edit webhook endpoint',
  form: {
    url: 'HTTPS endpoint URL',
    description: 'Description',
    description_placeholder: 'e.g. Order events for the POS',
    events: 'Events to deliver',
    events_required: 'Select at least one event.',
    events_hint: 'Only the selected events are delivered to this endpoint.',
    events_selected: '{{selected}} of {{total}}',
    event_groups: {
      order: 'Orders',
      store: 'Store',
      product: 'Products',
      modifier: 'Modifiers',
      menu_push: 'Menu pushes',
      payout: 'Payouts',
    },
    status: 'Status',
    status_active: 'Active',
    status_disabled: 'Disabled',
    status_auto_disabled: 'Auto-disabled (choose Active to re-enable)',
  },
  buttons: {
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
  },
  toasts: {
    created: 'Endpoint created.',
    updated: 'Endpoint updated.',
    error: 'Could not save the endpoint. Please try again.',
  },
};
